export interface IUser {
	Alias?: string;
	Department?: string;
	Division?: string;
	Email?: string;
	IsActive?: boolean;
	MobilePhone?: string;
	Title?: string;
	Username?: string;
}
